module.exports = __webpack_public_path__ + "img/server-avatar.d7ac675e.jpg";